import React from "react";

const ProjectCardSkeleton: React.FC = () => {
  return (
    <div className="p-4 w-full bg-white rounded-lg border border-gray-300 animate-pulse flex flex-col relative">
      {/* Date & Avatar Row */}
      <div className="flex justify-between items-center">
        <div className="w-16 h-3 bg-gray-300 rounded" />
        <div className="flex items-center space-x-[-10px]">
          <div className="w-8 h-8 bg-gray-300 rounded-full border-2 border-white" />
        </div>
      </div>

      {/* Title Row with ⭐️ icon */}
      <div className="flex items-center my-2 2xl:my-3">
        <div className="w-5 h-5 2xl:w-6 2xl:h-6 bg-gray-300 rounded mr-2" />
        <div className="h-5 w-3/4 bg-gray-300 rounded" />
      </div>

      {/* Description block: fixed height */}
      <div className="h-[4rem] 2xl:h-[5rem] flex flex-col justify-between mt-1 mb-2 bg-gray-200 rounded"></div>

      {/* Footer: Created by + file count */}
      <div className="flex justify-between items-center mt-4 text-xs 2xl:text-sm text-gray-500">
        <div className="h-4 w-1/2 bg-gray-200 rounded" />
        <div className="h-4 w-10 bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export default ProjectCardSkeleton;
